<template>
  <ul class="dialog-list">
    <li class="dialog-list__item">
      <div class="user-avatar dialog-avatar" @click.stop="setActiveDialog">
        <img v-if="user.avatar !== null && user.avatar.file_size"
             :src="user.avatar.path" :alt="user.profile.full_name">
        <img v-else src="/img/avatar-thumb.png" :alt="user.profile.full_name">
      </div>
      <!--<div class="dialog-list__item__counter">4</div>-->
    </li>
    <li class="dialog-list__item">
      <div class="user-avatar dialog-avatar">
        <img v-if="user.avatar !== null && user.avatar.file_size"
             :src="user.avatar.path" :alt="user.profile.full_name">
        <img v-else src="/img/avatar-thumb.png" :alt="user.profile.full_name">
      </div>
      <!--<div class="dialog-list__item__counter">12</div>-->
    </li>
    <li class="dialog-list__item">
      <div class="user-avatar dialog-avatar">
        <img v-if="user.avatar !== null && user.avatar.file_size"
             :src="user.avatar.path" :alt="user.profile.full_name">
        <img v-else src="/img/avatar-thumb.png" :alt="user.profile.full_name">
      </div>
      <!--<div class="dialog-list__item__counter">99+</div>-->
    </li>
  </ul>
</template>

<script>

export default {
  name: 'recent-dialogs',
  props: {},
  data () {
    return {
      user: {
        avatar: null,
        profile: {
          full_name: 'user'
        }
      }
    }
  },
  computed: {},
  methods: {
    setActiveDialog () {
      this.$emit('set-active-dialog')
    }
  },
  mounted () {}
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.dialog-list {
  margin-top: 14px;
  display: flex;
  flex-direction: column;

  &__item {
    position: relative;
    margin-bottom: 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    &__counter {
      position: absolute;
      height: 13px;
      min-width: 13px;
      border-radius: 7px;
      padding: 4px;
      top: auto;
      right: 12px;
      bottom: -2px;
      left: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 9px;
      background: $color_fifth;
      user-select: none;
    }
  }
}

.dialog-avatar {
  @include size(35px);
  box-shadow: none;
  border: none;
  cursor: pointer;
  user-select: none;
}

.router-link-active, .active {
  background: #F65F59;
  background: $button_color;
}
</style>
